import React, { useState } from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import Loader from "../../../../Layouts/Loader/Loader";
import Button from "../../../../components/FormComponents/Button";
import { toastSuccess } from "../../../../utils/toastUtils";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import Textarea from "../../../../components/FormComponents/Textarea";
import ReleaseRow from "./ReleaseRow";

const ReleaseInstancesList = ({ instances, isLoading, onAction, onPromote }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    instanceId: null,
    actionType: "",
    comment: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCopyId = (e, text, label) => {
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    toastSuccess(`Copied ${label} to clipboard`);
  };

  const openActionModal = (instanceId, type) => {
    setModalState({
      isOpen: true,
      instanceId,
      actionType: type,
      comment: ""
    });
  };

  const closeActionModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const handleConfirmAction = async () => {
    setIsSubmitting(true);
    try {
      await onAction(modalState.instanceId, {
        action: modalState.actionType,
        comment: modalState.comment
      });
      closeActionModal();
    } catch (error) {
      console.error("Action failed", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="p_4 d_flex justify_center">
        <Loader />
      </div>
    );
  }

  if (!instances || instances.length === 0) {
    return (
      <div
        className="p_5 border_full border_style_dashed border_radius_medium text_center color_secondary mt_4"
        style={{ backgroundColor: "#F4F5F7" }}
      >
        <MaterialIcon name="history" className="font_size_xlarge mb_2" style={{ opacity: 0.4, color: "#6B778C" }} />
        <div className="font_size_medium font_weight_medium" style={{ color: "#42526E" }}>
          No deployments yet
        </div>
        <div className="font_size_small mt_1" style={{ color: "#6B778C" }}>
          Your deployment history will appear here
        </div>
      </div>
    );
  }

  return (
    <div className="mt_4" style={{ overflow: "scroll", height: "calc(100vh - 350px)" }}>
      <div className="overflow_hidden">
        <div
          className="d_flex border_bottom_gray p_2 bg_transparent mb_3 overflow_hidden"
          style={{ borderBottom: "1px solid #DFE1E6" }}
        >
          <div className="text_left font_size_small font_weight_semibold w_30">Summary</div>
          <div className="text_left font_size_small font_weight_semibold w_20">Application</div>
          <div className="text_left font_size_small font_weight_semibold w_10">Version</div>
          <div className="text_left font_size_small font_weight_semibold w_15">Status</div>
          <div className="text_left font_size_small font_weight_semibold w_10">Activity</div>
          <div className="text_left font_size_small font_weight_semibold w_15">Actions</div>
        </div>
        <div className="d_flex flex_column gap_3">
          {instances.map((item, index) => {
            const isLast = index === instances.length - 1;
            return (
              <ReleaseRow
                key={item.id}
                item={item}
                isLast={isLast}
                onOpenModal={openActionModal}
                onCopyId={handleCopyId}
                onPromote={onPromote}
              />
            );
          })}
        </div>
      </div>
      <BuilderModal
        isOpen={modalState.isOpen}
        onClose={closeActionModal}
        modalName={modalState.actionType === "APPROVE" ? "Approve Deployment" : "Reject Deployment"}
      >
        <div className="d_flex flex_column gap_3 p_1">
          <div className="d_flex flex_column gap_1">
            <Textarea
              label="Comment"
              placeholder="Add your reason here..."
              value={modalState.comment}
              onChange={(e) => setModalState((prev) => ({ ...prev, comment: e.target.value }))}
            />
          </div>

          <div className="justify_end">
            <div className="d_flex gap_2">
              <Button variant="secondary" onClick={closeActionModal} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleConfirmAction}
                style={{ marginLeft: "0px" }}
                isLoading={isSubmitting}
              >
                Confirm {modalState.actionType === "APPROVE" ? "Approval" : "Rejection"}
              </Button>
            </div>
          </div>
        </div>
      </BuilderModal>
    </div>
  );
};

export default ReleaseInstancesList;
